import { Time } from '@angular/common';

export class Task {
  ParentId: string;
  ParentObjectType: string;
  IdRefPersonResubmissionFor: string;
  IdRefPersonResubmissionFrom: string;
  Body: string;
  Duration: number;
  EndDate: Date;
  Kind: string;
  NetmeetingType: string;
  Priority: number;
  StartDate: Date;
  StartTime: Time;
  Status: number;
  Subject: string;
  Type: number;

  constructor(data) {
    Object.assign(this, data);
  }
}
